import { useMemo } from 'react';
import { useKeywords } from '@app/hooks';
import { FlatExperience } from '@app/utils/types';

function useFlatExperiencesPage(eventData: any, groupSlug?: string) {
  const flatExperienceDataGroups = eventData?.homePage?.filter(
    (el: any) => el.__typename === 'ComponentFlexpsFlExpGr'
  );

  const keywords = useKeywords(
    flatExperienceDataGroups?.[0]?.flat_experience_groups?.[0]?.keywords || []
  );

  const { flatExperiencesListingData } = useMemo(() => {
    const flatExperiencesListingData: Array<{
      item: FlatExperience;
      groupId: string;
    }> = [];

    flatExperienceDataGroups.forEach((group: any) => {
      (group?.flat_experience_groups?.[0]?.flat_experiences || []).forEach(
        (item: FlatExperience) => {
          const groupId = group?.flat_experience_groups?.[0]?.slug;

          if (groupSlug && groupSlug !== groupId) return;

          flatExperiencesListingData.push({
            item,
            groupId,
          });
        }
      );
    });

    const finalData = flatExperiencesListingData.filter(
      (currentObject, index, self) => {
        return (
          index ===
          self.findIndex((obj) => obj.item.slug === currentObject.item.slug)
        );
      }
    );
    return { flatExperiencesListingData: finalData };
  }, [flatExperienceDataGroups]);

  return {
    flatExperiencesListingData,
    keywords,
  };
}

export default useFlatExperiencesPage;
